const React = require('react');
const CheckIcon = require('@material-ui/icons/Check').default;
const ButtonG = require('../Button/G');


module.exports = (props) => {
  const info = props.args || [];
  const name = info[0] || '';
  const text = info[1] || '';
  const icon = info[2] || (<CheckIcon className="dB-i f46-i mhA"/>);

  return (
    <div className="rlv cF">
      <div className="mb30">
        {icon}
      </div>
      {name ? (<div className="mb15 f18 fw5 tc lh160% break">{name}</div>) : null}
      {text ? (<div className="f16 fw5 tc lh160% break">{text}</div>) : null}
      <div className="mt40">
        <ButtonG
          className="w160 h48*2 mhA"
          onClick={props.onClose}
        >OK</ButtonG>
      </div>
    </div>
  );
};
